import { useEffect, useState } from 'react';
import { WPSearchResultItem } from '../../typings';
import * as styles from './SingleJobRow.module.scss';

// get the tags selected in settings
interface Window {
  cg_jobs_get_tags_data?: string[];
  cg_jobs_es_var?: {pathName?: string}
}
const selectedTags = (window as Window).cg_jobs_get_tags_data;
const cgJobsVars = (window as Window).cg_jobs_es_var;

const pathName = cgJobsVars?.pathName;
  let base_slug = '';

  if (pathName !== '') {
    base_slug = '/' + pathName;
  }

interface jobProps extends WPSearchResultItem {
  refId: string;
}
export const SingleJobRow: React.FC<jobProps> = (props) => {
  const [locations, setLocations] = useState(props.location);
  const [experienceText, setExperienceText] = useState(props.experience_level);
  const totalLocations = locations.split(",");  

  //if(totalLocations.length > 8) setLocations(`${totalLocations.slice(0, 8).join(",")} + ${totalLocations.length-8}`);
  const jobLink = (props.refId && props.source) ? `${base_slug}/jobs/${props.refId}+${props.source?.toLowerCase()}` : `${base_slug}/jobs/${props.id}`;

  useEffect(() => {
    const updateLocationNumbers = () => {
      if (window.matchMedia("(max-width: 1023px)").matches) {
        (props.experience_level === "Experienced Professionals") ? setExperienceText('Experienced') : setExperienceText(props.experience_level);
      } else {
        setExperienceText(props.experience_level);
      }

      if(window.matchMedia("(max-width: 429px)").matches) {
        if(totalLocations.length > 3) setLocations(`${totalLocations.slice(0, 3).join(",")} + ${totalLocations.length-3}`);
      } else if (window.matchMedia("(max-width: 1023px)").matches) {
        if(totalLocations.length > 4) setLocations(`${totalLocations.slice(0, 4).join(",")} + ${totalLocations.length-4}`);
      } else {
        if(totalLocations.length > 5) setLocations(`${totalLocations.slice(0, 5).join(",")} + ${totalLocations.length-5}`);
      }
    };

    updateLocationNumbers();  
    // Add an event listener for window resize
    window.addEventListener('resize', updateLocationNumbers);  
    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', updateLocationNumbers);
  }, []); 

  function updateLabel(label:string, filterType: string){
    const cg_jobs_translated_filters = (window as Window).cg_jobs_translated_filters;
    // Split the label into an array if it contains commas
    const labels = label?.split(',');

    // Translate each value and join them back into a comma-separated string
    const translatedLabels = labels?.map((singleLabel) => {
      const trimmedLabel = singleLabel?.trim(); // Remove extra spaces
      if (
        cg_jobs_translated_filters &&
        filterType in cg_jobs_translated_filters &&
        encodeURIComponent(trimmedLabel) in cg_jobs_translated_filters[filterType] &&
        cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)] !== ''
      ) {
        return cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)];
      }
      return trimmedLabel; // Return original label if no translation is found
    });

    return translatedLabels?.join(', '); // Join the translated labels back into a string
  }
  
  return (
    <li className={styles["job-card-wrapper"]}> 
      <a href={jobLink} className={styles["job-card"]}>
        <div>
          <div className={styles.title}>{props.title ? props.title : ""}</div>       
          <div className={styles.location}>{props.location? updateLabel(locations, 'location') : ""}</div>
        </div>
        <ul className={styles.features}>
            {(props.professional_communities && selectedTags?.includes('professional_communities') && window.innerWidth >= 1024) && <li className={styles['professional-communities']}>{updateLabel(props.professional_communities, 'professional_communities')}</li>}         
            {(props.department && selectedTags?.includes('department') && window.innerWidth >= 1024) && <li className={styles['department']}>{props.department}</li>}         
            {(props.sbu && selectedTags?.includes('sbu') && window.innerWidth >= 1024) && <li className={styles['business-unit']}>{props.sbu}</li>} 
            {props.contract_type && <li className={styles['contract-type']}>{updateLabel(props.contract_type, 'contract_type')}</li>}      
            {props.experience_level && <li className={styles['experience-level']}>{updateLabel(experienceText, 'experience_level')}</li>}    
        </ul>
      </a>
    </li>
  )
}